<template>
    <div>
        <div class="modal fade" id="withdraw" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true"
            data-bs-backdrop="true" style="background-color:rgba(0, 0, 0, 0.5);">
            <div class="modal-dialog modal-dialog-lg modal-dialog-centered">
                <div class="modal-content exo-2" style="border-radius: 20px;" :style="skin.header_desktop.nav_bar">
                    <button id="closeLoginW" :style="skin.my_account.close_btn" style="display: block;" type="button"
                        class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                    <h6 class="modal-title title text-center m-1 mb-2 p-1" id="exampleModalLabel">{{
                        translate('WITHDRAW') }}</h6>
                    <div class="modal-body p-1 m-2">
                        <div class="text-center">
                            <!-- <div class="text-center" style="font-size: 12px; color: lightgray;">
                                {{ translate('Click here to view the ') }}
                                <a :href="transactionFeesUrl" target="_blank" style="color: lightblue; text-decoration: underline;">
                                    {{ translate('Transaction Fees') }}
                                </a>
                                </div> -->
                            <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                <select v-model="selectedMethod" class="form-control input-login mr-sm-2 my-sm-0">
                                    <option disabled value="">{{ translate('choose_method') }}</option>
                                    <option v-for="method in methods" :key="method" :value="method">
                                        {{ method }}
                                    </option>
                                </select>
                            </div>
                            <div v-if="selectedMethod == 'CRIPTO'">
                                <form @submit.prevent="withdraw" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedCurrency" @change="handleCurrencyChange"
                                            class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('choose_currency') }}</option>
                                            <option v-for="currency in currencies" :key="currency" :value="currency">
                                                {{ currency }}
                                            </option>
                                        </select>
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">ADDRESS</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="address" id="address" type="text"
                                            :placeholder="translate('Address')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT USD</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount" @change="handleCurrencyChange" 
                                            type="number" step="0.01" min="0.01" :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="destinationTag" id="amountW" type="text"
                                            :placeholder="translate('destinationTag (optional)')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
                                    </div>
                                    <!-- Mostrar datos de pago si están disponibles -->
                                    <div v-if="Coin" class="payment-info mb-2 my-1">
                                        <div class="text-center mb-3">
                                            <!-- Código QR -->
                                            <!-- <img :src="withdrawData.qrCode" alt="QR Code" style="max-width: 150px; margin: 0 auto;"/> -->
                                        </div>

                                        <!-- Detalles de pago -->
                                        <div class="payment-details mb-3" style="color: aliceblue; font-size: 15px;">
                                            <div v-if="Coin.rate"
                                                class="d-flex justify-content-center align-items-center mb-2">
                                                <span><strong>{{ translate('Rate') }}:</strong> {{ amount }} USD = {{
                                                    (Coin.rate).toFixed(4) }} {{ paymentDataForm.Currency }} </span>
                                            </div>
                                        </div>
                                        <div v-if="Coin.minimumWithdrawFee" class="payment-details mb-3"
                                            style="color: aliceblue; font-size: 15px;">
                                            <span><strong>{{ translate('minimum Withdraw Fee') }}:</strong> {{
                                                Coin.minimumWithdrawFee }} {{ paymentDataForm.Currency }}</span>
                                        </div>

                                        <!-- Botón Confirmar -->
                                        <!-- <div class="text-center mt-4">
                                            <button class="btn btn-success btn-lg">{{ translate('confirm') }}</button>
                                        </div> -->
                                    </div>
                                    <div class="d-flex mb-1 align-content-center justify-content-center">
                                        <button id="submit_btnpw" type="submit" class="btn p-2 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;"
                                            :disabled="login_inProcess || !selectedCurrency">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Confirm Withdraw') }}
                                            </span> </button>
                                    </div>
                                </form>
                            </div>
                            <div v-if="selectedMethod == 'PIX'">
                                <form @submit.prevent="withdraw_pix" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <h4 style="color: aliceblue; font-size: 12px;">PIX KEY TYPE</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="pix_key_type" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Choose Pix Key') }}</option>
                                            <option v-for="pix_key_ty in pix_key_types" :key="pix_key_ty"
                                                :value="pix_key_ty">
                                                {{ pix_key_ty }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="pix_key_type != ''"
                                        class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="pix_key" id="amountW" type="text"
                                            :placeholder="translate('Pix Key')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="tax_id" id="amountW" type="text"
                                            :placeholder="translate('Identfication Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN BRL</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="0.01"
                                            min="0.01" :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-1 align-content-center justify-content-center">
                                        <button id="submit_btnpw" type="submit" class="btn p-2 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="!pix_key || !pix_key_type">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Confirm Withdraw') }}
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div v-if="selectedMethod == 'CRIPTO ARG'">
                                <form @submit.prevent="withdraw_cripto" class="p-1 my-3">
                                    <!-- Selección de moneda -->
                                    <h4 style="color: aliceblue; font-size: 12px;">ACCOUNT TYPE</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="typeSelected" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Choose Account Type') }}</option>
                                            <option v-for="pix_key_ty in type" :key="pix_key_ty"
                                                :value="pix_key_ty">
                                                {{ pix_key_ty }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-if="typeSelected != ''"
                                        class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="tax_id" id="amountW" type="text"
                                            :placeholder="typeSelected == 'CBU'?translate('CBU'):translate('ALIAS')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off">
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN ARS</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="0.01"
                                            min="0.01" :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-1 align-content-center justify-content-center">
                                        <button id="submit_btnpw" type="submit" class="btn p-2 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="!tax_id ">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Confirm Withdraw') }}
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div v-if="selectedMethod == 'CUENTA DE AHORROS'">
                                <form @submit.prevent="withdraw_quickly" class="p-1 my-3">
                                    <h4 style="color: aliceblue; font-size: 12px;">ELIJA EL BANCO</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="selectedBank" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Choose Bank') }}</option>
                                            <option v-for="bank in banks" :key="bank.name" :value="bank" >
                                                {{ bank.descripcion }}
                                            </option>
                                        </select>
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">AMOUNT IN COP</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="amount"  type="number" step="1" min="1"
                                            :placeholder="translate('Amount')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="usuTipdoc" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Document Type') }}</option>
                                            <option v-for="doc in docs" :key="doc" :value="doc">
                                                {{ doc }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="tax_id" id="destinationTag" type="number"
                                            :placeholder="translate('Identification Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardName" id="destinationTag" type="text"
                                            :placeholder="translate('Name')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="usuTelefono" id="destinationTag" type="text"
                                            :placeholder="translate('Phone Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="cardEmail" id="destinationTag" type="text"
                                            :placeholder="translate('Email')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <select v-model="tipoCuenta" class="form-control input-login mr-sm-2 my-sm-0">
                                            <option disabled value="">{{ translate('Choose Bank') }}</option>
                                            <option v-for="cuenta in cuentaType" :key="cuenta" :value="cuenta">
                                                {{ cuenta }}
                                            </option>
                                        </select>
                                    </div>
                                    <h4 style="color: aliceblue; font-size: 12px;">Account Number</h4>
                                    <div class="pb-2 font-size-custom mb-2 my-1 d-flex justify-content-center w-100">
                                        <input v-model="numCuenta"  type="number" step="1" min="1"
                                            :placeholder="translate('Account Number')"
                                            class="form-control input-login mr-sm-2  my-sm-0" autocomplete="off"
                                            required>
                                    </div>
                                    <div class="d-flex mb-1 align-content-center justify-content-center">
                                        <button id="submit_btnpw" type="submit" class="btn p-2 login-btn"
                                            :style="{ 'background-color': skin.main_modal_background, 'color': skin.main_modal_text }"
                                            style="color:black;width: 50%;" :disabled="!tipoCuenta || !numCuenta">
                                            <span v-if="loading">
                                                <i class="fas fa-spinner fa-spin"></i> <!-- Spinner -->
                                            </span>
                                            <span v-else>
                                                {{ translate('Confirm Withdraw') }}
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div v-if="withdrawDataForm?.error || status.message != ''"
                                :class="'alert alert-' + status.type" class="p-0" role="alert"
                                style="color:brown; font-size: 15px;">{{ withdrawDataForm.error || status.message }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: "withdraw",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            username: "",
            password: "",
            resetPassword: false,
            status: {
                message: "",
                type: ""
            },
            timeRemaining: "",
            intervalId: null,
            destinationTag: '',
            loading: false,
            cardName: '',
            cardEmail: '',
            selectedBank: '',
            usuTelefono: "",
            usuTipdoc: "",
            numCuenta: "",
            tipoCuenta: "",
            cuentaType: ["AHORRO", "CORRIENTE"],
            docs: ['CC', 'NIT'],
            pix_key_types: ['CPF', 'CNPJ', 'PHONE', 'EMAIL', 'EVP'],
            "tax_id": "",
            "pix_key_type": "",
            "pix_key": "",
            type:["ALIAS","CBU"],
            typeSelected: "",
            transactionFeesUrl: 'https://docs.0xprocessing.com/basic/general/transaction-fees', // URL para ver las Transaction Fees
            amount: 1.0,
            address: '',
            account:'',
            selectedMethod: 'CRIPTO ARG', // Moneda seleccionada
            methods: ['CRIPTO', 'PIX', 'CUENTA DE AHORROS','CRIPTO ARG'],
            login_inProcess: false,
            selectedCurrency: '', // Moneda seleccionada
            currencies: [
                'BTC', 'LTC', 'DASH', 'DOGE', 'BCH', 'XRP', 'CSC', 'ETH', 'USDT (ERC20)', 'USDC (ERC20)', 'TUSD (ERC20)', 'DAI (ERC20)', 'AXS (ERC20)', 'WEVER (ERC20)', 'TRX (ERC20)',
                'TRX', 'USDT (TRC20)', 'AXS (TRC20)', 'ETH (TRC20)',
                'BNB', 'USDT (BEP20)', 'USDC (BEP20)', 'DAI (BEP20)', 'BTCB (BEP20)', 'ETH (BEP20)', 'ADA (BEP20)', 'DESU (BEP20)', 'MDAO (BEP20)',
                'AVAX', 'USDT (AVAXC)', 'TUSD (AVAXC)', 'USDC (AVAXC)',
                'MATIC', 'USDT (POLYGON)', 'USDC (POLYGON)', 'WETH (POLYGON)',
                'ETH (ARB1)', 'USDT (ARB1)', 'DAI (ARB1)', 'USDC (ARB1)', 'WBTC (ARB1)',
                'TON', 'USDT (TON)', 'NOT (TON)',
                'ETH (BASE)', 'USDC (BASE)'
            ] // Lista completa de monedas
        }
    },
    computed: {
        formattedExpDate() {
            if (!this.withdrawData || !this.withdrawData.expDate) return '';
            const expDate = new Date(this.withdrawData.expDate);
            return `${expDate.toLocaleDateString()} ${expDate.toLocaleTimeString()}`;
        },
        withdrawData() {
            // console.log(this.$store.getters["getWithdrawData"])
            let data = this.$store.getters["getWithdrawData"].withdrawalData != undefined ? this.$store.getters["getWithdrawData"].withdrawalData != undefined : this.$store.getters["getWithdrawData"]
            // console.log(data)
            return data
        },
        withdrawDataForm() {
            // console.log(this.$store.getters["getWithdraw"])
            let data = this.$store.getters["getWithdraw"].withdrawalData != undefined ? this.$store.getters["getWithdraw"].withdrawalData != undefined : this.$store.getters["getWithdraw"]
            // console.log(data)
            return data
            // return this.$store.getters["getWithdraw"]

        },
        banks() {
            // console.log(this.$store.getters["getQuicklyPayBanks"])
            return this.$store.getters["getQuicklyPayBanks"]
        },
        paymentDataForm() {
            return this.$store.getters["getPaymentData2"]
        },
        Coin() {
            // console.log(this.$store.getters["getCoin_info2"])
            return this.$store.getters["getCoin_info2"]
        },
        paymentData() {
            let data = this.$store.getters["getPayment2"].paymentData ?? this.$store.getters["getPayment2"]
            // console.log(data)
            return data
        },
        combinedData() {
            return {
                amount: this.amount,
                selectedCurrency: this.selectedCurrency,
                destinationTag: this.destinationTag,
            };
        },
    },
    methods: {
        async withdraw() {
            if (!this.selectedCurrency) {
                this.status.message = this.translate("choose_currency");
                this.status.type = "danger";
                return;
            }
            this.loading = true;
            // console.log(this.Coin.rate)
            this.$store.dispatch('setAmount', { Currency: this.selectedCurrency, DestinationTag: this.destinationTag, Amount: this.Coin.rate, AmountUSD: parseFloat(this.amount), Address: this.address });
            // this.$store.dispatch('setCurrency', {Currency:this.selectedCurrency,DestinationTag:this.destinationTag});
            setTimeout(async () => {
                // await this.$store.dispatch("getPayment");
                setTimeout(async () => {
                    await this.$store.dispatch("getWithdraw");
                }, 10);
            }, 200);
            // Lógica de envío a la store de Vuex
            setTimeout(async () => {
                this.loading = false;
                if (!this.withdrawDataForm.error) {

                }
                setTimeout(async () => {
                    document.getElementById('closeLoginW').click();
                }, 300);
            }, 2000);
        },
        async withdraw_quickly() {
            let data = { usuDoc: this.tax_id, usuCorreo: this.cardEmail, usuNombre: this.cardName, usuTipdoc: this.usuTipdoc, usuTelefono: this.usuTelefono, numCuenta: this.numCuenta, tipoCuenta: this.tipoCuenta, bank: this.selectedBank.bank, valor: this.amount.toString() }
            this.loading = true;
            console.log(data)
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('setQuicklydataWD', data);
            setTimeout(async () => {
                await this.$store.dispatch("getQuicklyWD");
                this.loading = false;
            }, 500);
        },
        async withdraw_cripto() {
            let data = { alias: this.tax_id, type: this.typeSelected}
            this.loading = true;
            console.log(data)
            // Lógica de envío a la store de Vuex
            await this.$store.dispatch('setCriptodataWD', {data, amount: this.amount});
            setTimeout(async () => {
                await this.$store.dispatch("getCriptoWD");
                this.loading = false;
            }, 500);
        },
        async withdraw_pix() {
            this.status.message = "";
            this.status.type = "";

            // Validar campos obligatorios
            if (!this.pix_key_type || !this.pix_key || !this.tax_id) {
                this.status.message = this.translate("All fields are required");
                this.status.type = "danger";
                return;
            }

            // Expresiones regulares para validar formatos
            const regexCPF = /^(?:\d{3}\.\d{3}\.\d{3}-\d{2}|\d{11})$/;
            const regexCNPJ = /^(?:\d{2}\.\d{3}\.\d{3}\/0001-\d{2}|\d{14})$/;
            const regexPhone = /^(?:\+55\d{11,12}|\d{10,11})$/;
            const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const regexEVP = /^[a-fA-F0-9-]{36}$/;

            // Validar tax_id según el país
            if (!regexCPF.test(this.tax_id) && !regexCNPJ.test(this.tax_id)) {
                this.status.message = this.translate("Invalid tax ID format");
                this.status.type = "danger";
                return;
            }

            // Validar pix_key según el tipo seleccionado
            switch (this.pix_key_type) {
                case "CPF":
                    if (!regexCPF.test(this.pix_key)) {
                        this.status.message = this.translate("Invalid CPF format");
                        this.status.type = "danger";
                        return;
                    }
                    break;
                case "CNPJ":
                    if (!regexCNPJ.test(this.pix_key)) {
                        this.status.message = this.translate("Invalid CNPJ format");
                        this.status.type = "danger";
                        return;
                    }
                    break;
                case "PHONE":
                    if (!regexPhone.test(this.pix_key)) {
                        this.status.message = this.translate("Invalid phone format");
                        this.status.type = "danger";
                        return;
                    }
                    break;
                case "EMAIL":
                    if (!regexEmail.test(this.pix_key)) {
                        this.status.message = this.translate("Invalid email format");
                        this.status.type = "danger";
                        return;
                    }
                    break;
                case "EVP":
                    if (!regexEVP.test(this.pix_key)) {
                        this.status.message = this.translate("Invalid EVP format");
                        this.status.type = "danger";
                        return;
                    }
                    break;
                default:
                    this.status.message = this.translate("Invalid PIX key type");
                    this.status.type = "danger";
                    // this.$store.commit("getPayment",{error:"Invalid PIX key type"})
                    return;
            }

            this.loading = true;
            this.status.message = this.translate("");

            // Enviar datos al store Vuex
            this.$store.dispatch("setAmountPix", {
                data: {
                    tax_id_country: "BRA",
                    tax_id: this.tax_id,
                    pix_key_type: this.pix_key_type,
                    pix_key: this.pix_key
                },
                amount: parseFloat(this.amount)
            });

            setTimeout(async () => {
                await this.$store.dispatch("getPixWithdraw");
            }, 200);

            setTimeout(async () => {
                this.loading = false;
                if (!this.withdrawDataForm.error) {
                    this.status.message = this.translate("Withdrawal request sent successfully");
                    this.status.type = "success";
                }
                setTimeout(async () => {
                    document.getElementById("closeLoginW").click();
                }, 1000);
            }, 2000);
        },
        handleCurrencyChange: _.debounce(async function () {
            await this.$store.dispatch('setCurrency2', {
                Currency: this.selectedCurrency,
                DestinationTag: this.destinationTag,
                Amount: parseFloat(this.amount),
            });
        }, 300),
        translate(text) {
            if (text) {
                const translatedText = this.$props.translation[text] || this.$props.translation[text.replace(/ /g, "_")];
                return translatedText ? translatedText[this.$props.language] : text;
            }
        },
        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(() => {
                this.status = { message: this.translate("copied_to_clipboard"), type: "success" };
            });
        },
        startCountdown(expDate) {
            clearInterval(this.intervalId);

            this.intervalId = setInterval(() => {
                const now = new Date();
                const remainingTime = expDate - now;

                if (remainingTime <= 0) {
                    clearInterval(this.intervalId);
                    this.timeRemaining = this.translate("expired");
                } else {
                    const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
                    this.timeRemaining = `${minutes}m ${seconds}s`;
                }
            }, 1000);
        }
    },
    watch: {
        combinedData: {
            deep: true,
            handler(newValues, oldValues) {
                this.handleCurrencyChange();
            },
        },
    },
}
</script>


<style scoped>
.title {
    font-family: "Exo 2", sans-serif;
    color: #ebebd3 !important;
    height: 10px !important;
    font-size: 1rem !important;
    font-weight: bold;
    margin-bottom: 2px;
    margin: 0.5rem auto;
}

.login-btn {
    font-family: "Exo 2", sans-serif;
    color: black !important;
    font-size: small !important;
    font-weight: bold;
    margin-bottom: 12px;
    margin: 0.5rem auto;
}

.exo-2> {
    font-family: "Exo 2", sans-serif !important;
}

.input-login {
    background-color: #020f1d;
    font-family: "Exo 2", sans-serif;
    border: none;
    color: #fff;
    font-size: medium;
    border-radius: 6px;
    padding: 10px 20px;
    line-height: .75em;
}

.modal-fade {
    border-radius: 10px 10px 10px 10px;
}

.modal-title {
    margin-left: 5% !important;
    margin-right: 5% !important;
    margin-top: 0.15rem !important;
    margin-bottom: 0 !important;
    height: 10px;
    padding: 0.5rem !important;
    color: #fff;
    border-bottom: none;
    font-size: 20px;
    font-family: Exo 2, sans-serif;
}

.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .5;
}

.login-user-control {
    color: #fff;
    width: 200%;
    -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 20px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0 auto;
    /* Alinear horizontalmente */
    padding: 0.6rem 0 0.6rem;
    background-image: none;
    background-color: transparent;
    height: auto;
    font-family: Exo 2, sans-serif;
    font-weight: 800;
}

.modal-title {
    height: 50px;
    color: #fff;
    border-bottom: none;
    font-size: 20px;
    font-family: Exo 2, sans-serif;
}

.close2 {
    float: right;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .8;
}

.login-user-control,
.submit_btn {
    text-align: center;
    color: #fff;
    width: 100%;
    -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    -o-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
    outline: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 20px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: transparent;
    margin: 0;
    /* Alinear horizontalmente */
    padding: 0.5rem 8rem;
    background-image: none;
    background-color: transparent;
    height: auto;
    font-family: Exo 2, sans-serif;
    font-weight: 800;
}
</style>
